module.exports = __webpack_public_path__ + "static/img/MV18.2512082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV18.jpg
// module id = qEe9
// module chunks = 0